import { useQuery } from '@tanstack/react-query';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import { TourStatus } from '@/features/dashboard/tours/types/TourStatus.ts';

const useGetCancellationReadiness = (tourId: string, status: TourStatus) => {
  return useQuery({
    queryKey: toursApiQueryKeys.cancellationReadiness(tourId),
    queryFn: () => toursApi.getCancellationReadiness(tourId),
    enabled: status === TourStatus.READY,
  });
};

export default useGetCancellationReadiness;
